import XcolumnFunc from "@/pcomponents/common/xcolumn/xcolumn/xcolumn_func";
//const xColumnArr=getXcolumnJson();

const getXcolumnJson=()=>{
  let initData:any={
    table:"word_inside_use",
    list_id:"word_inside_use_list_popup",
    x_column_list_arr:[
      {"key":"a_stu_name","name":"학생명","width":"100","is_show":"1"},
      {"key":"a_re_start_date","name":"재시작일","width":"100","is_show":"1"},
      {"key":"row_view_result","name":"수행률","width":"110","is_show":"1"},
      {"key":"row_view_result_pop","name":"결과보기","width":"100","is_show":"1"},
    ],
    list_opt_origin:{
      'now_page':1,
      'num_per_page':30,
      'order_id':'',
      'order_type':'',
      's_date_type':'',
      's_start_date':'',
      's_end_date':'',
      'sc':{},
      "is_add_idx_info":"1",
    },
    order_id_col_arr:[
      {"value":"","text":"없음"},
    ]
  };
  initData.pri_col_arr=["a_in_seq","a_stu_mcomp_seq","a_stu_seq"];
  const xColumnArr:any=XcolumnFunc.getDefaultXcolumn(initData);
  
  return xColumnArr;
};

export default getXcolumnJson;